import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { compose, withProps } from 'recompose';
import { withRouter } from 'react-router-dom';
import { withFirestore } from 'react-redux-firebase';
import {
  text__primary,
  text__primary_dark,
  white,
  deepPurple,
  grey,
  grey_dark,
  text__secondary
} from '../../style';

const styles = theme => ({
  root: {
    width: '100%',
    minHeight: '500px'
  },
  layout: {
    width: 'auto',
    background: '#f5f6fa',
    paddingTop: theme.spacing.unit * 7,
    paddingBottom: theme.spacing.unit * 10,
    paddingLeft: theme.spacing.unit * 4,
    paddingRight: theme.spacing.unit * 4,
    [theme.breakpoints.up(600 + theme.spacing.unit * 4 * 2)]: {
      width: '100%',
      boxSizing: 'content-box'
    }
  },
  header: {
    marginBottom: '15px'
  },
  title: {
    color: deepPurple
  },
  descriptionContainer: {
    marginTop: '30px',
    maxHeight: '100px',
    overflow: 'hidden'
  },
  tableCell: {
    paddingTop: '30px',
    paddingBottom: '30px'
  },
  icon: {
    color: 'red',
    width: '25px',
    height: '25px'
  },
  space: {
    marginTop: '30px',
    marginBottom: '30px'
  },
  search: {
    background: grey,
    borderRadius: '4px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '10px'
  },
  searchInput: {
    width: '100%'
  },
  filterButton: {
    minWidth: '131px',
    background: text__primary,
    color: white,
    '&:hover': {
      background: text__primary_dark
    }
  },
  applyFilterButton: {
    color: white
  },
  refresh: {
    marginLeft: '5px',
    marginRight: '5px',
    color: text__primary
  },
  expandPanel: {
    boxShadow: 'none'
  },
  companyList: {
    paddingLeft: '24px',
    paddingRight: '24px',
    paddingBottom: '30px'
  },
  listRow: {
    padding: 24,
    borderBottom: '1px solid #c5c5c5',
    display: 'flex',
    flexWrap: 'nowrap',
    [theme.breakpoints.down('xs')]: {
      display: 'block'
    },
    '&:nth-first-child': {
      paddingTop: 0
    },
    '&:nth-last-child': {
      paddingBottom: 30,
      borderBottom: 'none'
    }
  },
  gridSort: {
    justifyContent: 'flex-end',
    [theme.breakpoints.down('sm')]: {
      marginTop: '10px',
      justifyContent: 'flex-start'
    }
  },
  sort: {
    minWidth: '100px'
  },
  youtubeIcon: {
    color: white
  },
  pagination: {
    marginTop: 20,
    paddingLeft: 0,
    display: 'flex',
    justifyContent: 'center',
    listStyle: 'none',

    '& > .active > a': {
      border: '1px solid #233d4d',
      background: '#000000',
      color: text__primary
    },

    '& > .break-me > a': {
      border: 'none'
    },

    '& > .previous > a, & > .next > a': {
      border: 'none',
      color: text__primary,
      [theme.breakpoints.down('xs')]: {
        display: 'block'
      }
    },

    '& > li > a': {
      marginLeft: 5,
      marginRight: 5,
      paddingTop: 3,
      paddingBottom: 3,
      paddingLeft: 7,
      paddingRight: 7,
      cursor: 'pointer',
      border: '1px solid #000',
      borderRadius: 4,
      color: text__secondary,
      outline: 'none',
      [theme.breakpoints.down('xs')]: {
        display: 'none'
      }
    }
  },
  selectMenu: {
    '& .MuiPopover-paper': {
      maxHeight: 250
    }
  },
  select: {
    width: '250px',
    marginTop: '0px',
    background: 'white',
    '& > *': {
      maxWidth: 500,
      width: '100%',
      margin: '0 auto'
    }
  },
  circleImage: {
    objectFit: 'cover',
    borderRadius: '50%',
    width: '96px',
    height: '96px'
  }
});

const mapStateToProps = state => {
  return {
    profile: state.firebase.profile
  };
};

export default compose(
  withFirestore,
  connect(
    mapStateToProps,
    null
  ),
  withProps(({ profile, campaigns }) => ({
    profile
    // campaigns
  })),
  withStyles(styles),
  // Add props.router (used in handlers)
  withRouter
);



// WEBPACK FOOTER //
// ./src/components/influencer/Discover.enhancer.js